import { TypedUseSelectorHook, useSelector } from "react-redux";
import { DefaultState } from "../redux";


export const useAppSelector: TypedUseSelectorHook<DefaultState> = useSelector